import { ApolloProvider } from "@apollo/client";
import { useAuth } from "@clerk/nextjs";
import { AppProps } from "next/app";
import { ReactNode } from "react";
import {
  APOLLO_STATE_PROPERTY_NAME,
  initializeApollo,
} from "@/lib/apollo/apollo";

export default function ApolloProviderWrapper({
  isMobileApp,
  children,
  pageProps,
}: {
  isMobileApp: boolean;
  children: ReactNode;
  pageProps: AppProps["pageProps"];
}) {
  const { getToken: getClerkToken, signOut } = useAuth();
  const state = pageProps[APOLLO_STATE_PROPERTY_NAME] as Record<
    string,
    unknown
  >;

  const apolloClient = initializeApollo({
    initialState: state,
    getClerkToken,
    signOut,
    isMobileApp,
  });

  return <ApolloProvider client={apolloClient}>{children}</ApolloProvider>;
}
